import React, {lazy} from 'react';
import { AuthRoute } from '../auth/components';

//import { JourneysPage, JourneyDetailsPage, JourneysDashboard, JourneySettings } from './pages';
import sagas from './sagas';
import reducers from './reducers';
import { ActionsDashboard } from '../actions/pages';
import { USER_ROLE } from '@utils/authorisation';
import AvTimerOutlinedIcon from '@mui/icons-material/AvTimerOutlined';


const JourneysPage = lazy(() => import('./pages/JourneysPage'));
const JourneyDetailsPage = lazy(() => import('./pages/JourneyDetailsPage'));
const PartnerJourneyDetailsPage = lazy(() => import('./pages/PartnerJourneyDetailsPage'));
const JourneysDashboard = lazy(() => import('./pages/JourneysDashboard'));
const JourneySettings = lazy(() => import('./pages/JourneySettings'));
const JourneysActivityPage = lazy(() => import('./pages/JourneysActivityPage'));

const journeysModule = {
  routes: [
    <AuthRoute key="journeys" exact path="/journeys" component={JourneysPage} headerType={'private'} />,
    <AuthRoute key="journey-details" exact path="/journey-details/:journeyId" component={JourneyDetailsPage} headerType={'private'} />,
    <AuthRoute
      key="partner-journey-details"
      exact
      path="/partner-journey-details/:journeyId"
      component={PartnerJourneyDetailsPage}
      headerType={'private'}
      authorization={[USER_ROLE.Partner_Admin, USER_ROLE.Partner_Supervisor, USER_ROLE.Partner_Member, USER_ROLE.Admin, USER_ROLE.Supervisor, USER_ROLE.SettlementsCoordinator]}
    />,
    <AuthRoute
      key="journeys-dashboard"
      exact
      path="/journeys-dashboard"
      component={JourneysDashboard}
      headerType={'private'}
      authorization={[USER_ROLE.Admin, USER_ROLE.OperationsManager, USER_ROLE.Supervisor, USER_ROLE.SettlementsCoordinator, USER_ROLE.Conveyancer, USER_ROLE.Specialist, USER_ROLE.Audit, USER_ROLE.Partner_Admin, USER_ROLE.Partner_Supervisor, USER_ROLE.Partner_Member]}
    />,
    <AuthRoute key="journey-settings" exact path="/journey-settings/:journeyId" component={JourneySettings} headerType={'private'} isSpecialistOnly />,
    <AuthRoute key="journey-actions" exact path="/journey-actions/:journeyId" component={ActionsDashboard} headerType={'private'} isSpecialistOnly />,
    <AuthRoute key="journeys-activity" exact path="/journeys-activity" component={JourneysActivityPage} headerType={'private'} isSpecialistOnly />
  ],
  sagas,
  reducers: { journeys: reducers }
};

export default journeysModule;
